import {
    Card,
    Table,
    TableContainer,
    TablePagination,
    Grid,
    Typography,
    Avatar,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    Paper,
    Stack,
    useMediaQuery,
    useTheme,
    Divider,
    createTheme,
    Box,
    Tooltip,
    IconButton,
    Tab,
    Tabs
} from '@mui/material';
import { useState } from 'react';
import HttpServices from 'src/services/httpService';
import { userModuleURL, imageModeuleUrl, postsModuleURL } from 'src/services/urlService';
import { useToaster } from 'src/utils/toaster/toasterContext';
import NoApproval from 'src/assets/app-image/no-generated-posts.svg';
import { PostDetailsHelper } from 'src/utils/postDetailsHelper';
import { CommonHelper } from 'src/utils/commonHelper';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { AccountBoxSharp as AccountBoxSharpIcon } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useRightSidebar } from 'src/layouts/right-side-bar/rightSidebarProvider';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmationDialog from "src/components/ConfirmationDialog";
import GeneratedPostPendingApprovalGridActionPopup from './generated-post-pending-approval-grid-action-popup.component';
import PostPreview from 'src/pages/scheduledPost/Preview/post-preview.component';
import PostReviewComments from 'src/pages/scheduledPost/Preview/post-preview-comment.component';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

const GeneratedPostPendingApprovalGrid = ({ pendingApprovalList, handleReCallPendingApprovalPost, order, orderBy }) => {
    const { t: translate } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    //Table Variables
    const [selectedPopOverPost, setPopOverPost] = useState(null);
    const [popoverElement, setPopoverElement] = useState(null);
    const [loading, setLoading] = useState(false);
    const [confirmationDialogue, setConfirmationDialogue] = useState(null);
    const { showToast } = useToaster();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
    const { urlKey } = useParams();
    const POPUP_WIDTH = isMobile ? '300px' : '500px';
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [mediaIndex, setMediaIndex] = useState({});


    const handleToggleDescription = (postId) => {
        setExpandedDescriptions(prev => ({
            ...prev,
            [postId]: !prev[postId]
        }));
    };


    const handleCloseMenu = () => {
        setPopOverPost(null);
        setPopoverElement(null);
    };

    const closeConfirmationDialogue = () => {
        setConfirmationDialogue(null)
    };

    const failureCallback = (message) => {
        message && showToast(message, 'e');
        handleCloseMenu();
        closeConfirmationDialogue()
        setLoading(false);
    };

    const fetchMediaMetaData = (data, editAsNew = false) => {
        let mediaBody = {
            media_urls: data?.media_url.split(",")
        };
        let postProps = {
            url: imageModeuleUrl.fetchMediaMetadata,
            body: mediaBody,
            successCallback: (imageData, message) => { fetchMediaSuccessCallback(imageData, message, data, editAsNew) },
            failureCallback: failureCallback
        }
        HttpServices.Post(postProps);
    }
    const fetchMediaSuccessCallback = (imageData, mesaage, data, editAsNew) => {
        if (editAsNew) {
            uploadEditDataToNewPost(data, imageData ? imageData.media_datas : []);
        }
        else {
            uploadDataToPost(data, imageData ? imageData.media_datas : []);
        }

    }
    const newPostSucessCallback = (data) => {
        if (data.media_url && data.media_url.length > 0)
            fetchMediaMetaData(data);
        else
            uploadDataToPost(data);
    }

    const editNewPostSucessCallback = (data) => {
        let editAsNew = true
        if (data.media_url && data.media_url.length > 0)
            fetchMediaMetaData(data, editAsNew);
        else
            uploadEditDataToNewPost(data);
    }

    const uploadDataToPost = (data, imageData = []) => {
        setLoading(false);
        const updatedData = {
            ...data,
            media_data: imageData,
            schedule_id: selectedPopOverPost?.id
        };
        const newPostData = CommonHelper.CommonNewPostAddMediaAllService(updatedData, imageData)
        navigate('/new-post', { state: { data: newPostData } });
    }
    const uploadEditDataToNewPost = (data, imageData = []) => {
        setLoading(false);
        const newPostData = CommonHelper.CommonNewPostAddMediaAllService(data, imageData)
        navigate('/new-post', { state: { data: newPostData } });
    }
    const handleEditPost = () => {
        setLoading(true);
        CommonHelper.SetIsOrgLevelEvent(false);
        CommonHelper.CommonNewPostStruct(false,selectedPopOverPost?.id, newPostSucessCallback, failureCallback)
    };
    const handleEditAsNewPost = () => {
        setLoading(true);
        CommonHelper.SetIsOrgLevelEvent(false);
        CommonHelper.CommonNewPostStruct(false,selectedPopOverPost?.id, editNewPostSucessCallback, failureCallback)
    };

    const handleApprovePost = (row) => {
        handleCloseMenu();
        setConfirmationDialogue({
            isOpen: true,
            title: translate('generated_post_pending_approval_grid.confirm_post_now', 'Confirm Post Now'),
            message: translate('generated_post_pending_approval_grid.approve_schedule_message', 'Are you sure you want to Approve this Schedule?'),
            submitFunction: () => confirmApprovePost(row)
        });
    };

    const confirmApprovePost = (row) => {
        setLoading(true); 
        let props = {
            schedule_ids: [row.id],
        };
        let postProps = {
            url: userModuleURL.approveGeneratedPost,
            body: props,
            successCallback: approvePostSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
    };

    const approvePostSuccessCallback = (data, message) => {
        setLoading(false); // Reset loading when done
        message && showToast(message);
        handleCloseMenu();
        closeConfirmationDialogue();
        handleReCallPendingApprovalPost();
    };


    const handleDeletePost = (row) => {
        handleCloseMenu()
        setConfirmationDialogue({
            isOpen: true,
            title: translate('generated_post_pending_approval_grid.confirm_deletion', 'Confirm Deletion'),
            message: translate('generated_post_pending_approval_grid.delete_schedule_message', 'Are you sure you want to delete this Schedule?'),
            submitFunction: () => confirmDeletePost(row)
        })
    };

    const confirmDeletePost = (row) => {
        setLoading(true); // Set loading to true before starting the delete process
        let postProps = {
            url: postsModuleURL.deleteSchedule + row.id,
            successCallback: deleteSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
        closeConfirmationDialogue();
    };


    const deleteSuccessCallback = (data, message) => {
        setLoading(false); // Reset loading to false after successful deletion
        message && showToast(message);
        handleCloseMenu();
        closeConfirmationDialogue()
        handleReCallPendingApprovalPost();
    };


    const handleSaveAsDraft = () => {
        let props = {
            schedule_post_id: selectedPopOverPost?.id,
        };
        let postProps = {
            url: postsModuleURL.savePostAsDraft,
            body: props,
            successCallback: saveAsDraftSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
    };

    const saveAsDraftSuccessCallback = (data, message) => {
        message && showToast(message);
        handleCloseMenu();
    };

    const handleRejectPost = (row) => {
        handleCloseMenu()
        setConfirmationDialogue({
            isOpen: true,
            title: translate('generated_post_pending_approval_grid.confirm_deletion', 'Confirm Deletion'),
            message: translate('generated_post_pending_approval_grid.reject_schedule_message', 'Are you sure you want to Reject this Schedule?'),
            submitFunction: () => confirmRejectPost(row)
        })
    };

    const confirmRejectPost = (row, message) => {
        let props = {
            schedule_id: row.id,
        };
        let postProps = {
            url: userModuleURL.rejectPostPublic + `?url_key=${urlKey}`,
            body: props,
            successCallback: unapproveSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
    }

    const unapproveSuccessCallback = (data, message) => {
        message && showToast(message, 's');
        handleCloseMenu();
        closeConfirmationDialogue()
        handleReCallPendingApprovalPost();
    };

    const postActionProps = {
        popoverElement: popoverElement,
        popoverElement,
        handleCloseMenu,
        approvePost: handleApprovePost,
        editAsNewPost: handleEditAsNewPost,
        editPost: handleEditPost,
        saveAsDraft: handleSaveAsDraft,
        deletePost: handleDeletePost,
        loading,
        selectedPopOverPost: selectedPopOverPost,
    };


    const handleOpenScheduledPost = (row, open = false, selectTab = 0) => {
        let data = {
            content: (rowId) => postView(rowId, selectTab),
            data: row,
        };
        showRightSidebar(data, POPUP_WIDTH);
    };

    const postView = (row, selectTab = 0) => {
        let postDetails = {
            data: { id: row },
        };
        return <PublicDetailsPreview postDetails={postDetails} selectTab={selectTab} />;
    };

    const { showRightSidebar } = useRightSidebar();
    const ACCOUNT_TABS = (postDetails) => [
        {
            value: 'Preview Event',
            icon: <AccountBoxSharpIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
            component: <PostPreview postDetails={postDetails} urlKey={urlKey} />,
        },
        {
            value: 'Review Comments',
            icon: <AccountBoxSharpIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
            component: <PostReviewComments PostDetails={postDetails} urlKey={urlKey} />,
        }
    ];

    const PublicDetailsPreview = ({ postDetails, selectTab = 0 }) => {
        const tabs = ACCOUNT_TABS(postDetails);
        const [currentTab, setCurrentTab] = useState(tabs[selectTab].value);

        const handleChange = (event, newValue) => {
            setCurrentTab(newValue);
        };

        return (
            <Box>
                <Tabs
                    value={currentTab}
                    onChange={handleChange}
                    scrollButtons="auto"
                    variant="scrollable"
                    sx={{ gap: '0.5rem', minHeight: '37px' }}
                    allowScrollButtonsMobile
                >
                    {tabs.map((tab) => (
                        <Tab
                            key={tab.value}
                            value={tab.value}
                            label={tab.value}
                            icon={tab.icon}
                            sx={{
                                flexDirection: 'row',
                                gap: '0.25rem',
                                padding: 1,
                                minHeight: '10px',
                                mr: '0.75rem',
                                ml: '0.75rem',
                                fontWeight: 600,
                            }}
                            disableRipple
                        />
                    ))}
                </Tabs>
                <Box sx={{ mb: 2 }} />
                <Box>
                    {tabs.find((tab) => tab.value === currentTab)?.component}
                </Box>
            </Box>
        );
    };

    return (
        <>
            {pendingApprovalList && pendingApprovalList.length > 0 ? (
                <>
                    <Box style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 'calc(70vh - 120px)',
                        maxHeight: 'calc(90vh - 120px)',
                        overflowY: 'auto',
                        padding: theme.spacing(2)
                    }}>
                        <Grid container spacing={2}>
                            {pendingApprovalList.map(row => {
                                const isExpanded = !!expandedDescriptions[row.id];
                                const mediaUrls = row.media_url ? row.media_url.split(',') : [];

                                const handlePrevMedia = (postId, total) => {
                                    setMediaIndex(prev => ({
                                        ...prev,
                                        [postId]: prev[postId] > 0 ? prev[postId] - 1 : total - 1
                                    }));
                                };
                                const handleNextMedia = (postId, total) => {
                                    setMediaIndex(prev => ({
                                        ...prev,
                                        [postId]: prev[postId] < total - 1 ? prev[postId] + 1 : 0
                                    }));
                                };
                                return (
                                    <Grid item xs={12} sm={6} lg={4} key={row.id}>
                                        <Card
                                            sx={{
                                                width: '100%',
                                                height: 600, // Fixed height for all cards
                                                display: 'flex',
                                                flexDirection: 'column',
                                                boxShadow: 'none',
                                                border: 'solid 2px',
                                                borderColor: theme.palette.preview.postcard.color,
                                            }}
                                        >
                                            <CardHeader
                                                title={PostDetailsHelper.getSocialMediaProfiles(row?.connected_profile_details)}
                                                subheader={
                                                    <Stack direction="row" alignItems="center" spacing={2} marginTop={2}>
                                                        {CommonHelper.formatDateAndTime(row?.scheduled_time)}
                                                    </Stack>
                                                }
                                                action={
                                                    <IconButton
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ padding: '6px', marginRight: '2px' }}
                                                        onClick={e => {
                                                            setPopOverPost(row);
                                                            setPopoverElement(e.currentTarget);
                                                        }}
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                }
                                            />
                                            <CardContent sx={{ pt: 0.5, pb: 0.5, flex: 1, minHeight: 40,  overflow: 'hidden' }}>
                                                <Typography
                                                    noWrap={!isExpanded}
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitBoxOrient: 'vertical',
                                                        WebkitLineClamp: isExpanded ? 'initial' : 3,
                                                        overflow: 'hidden',
                                                        WebkitBoxDecorationBreak: 'clone',
                                                        whiteSpace: 'pre-line',
                                                        textOverflow: 'ellipsis',
                                                        fontSize: '0.8rem',
                                                        lineHeight: 1.3,
                                                        minHeight: 24,
                                                    }}
                                                >
                                                    {row.description}
                                                </Typography>
                                                {!isExpanded && row.description.length > 100 && (
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            fontWeight: 700,
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8rem',
                                                            color: theme.palette.primary.main,
                                                            mt: 0.5
                                                        }}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            handleToggleDescription(row.id);
                                                        }}
                                                    >
                                                        Show More
                                                    </Typography>
                                                )}
                                                {isExpanded && (
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            fontWeight: 700,
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8rem',
                                                            color: theme.palette.primary.main,
                                                            mt: 0.5
                                                        }}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            handleToggleDescription(row.id);
                                                        }}
                                                    >
                                                        Show Less
                                                    </Typography>
                                                )}
                                            </CardContent>
                                            {mediaUrls.length > 0 && (
                                                <Box sx={{ position: 'relative', pl: 2, pr: 2, minHeight: 120, maxHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', bgcolor: theme.palette.background.paper, borderRadius: 2, boxShadow: 1 }}>
                                                    {mediaUrls.length > 1 && (
                                                        <IconButton
                                                            size="medium"
                                                            sx={{
                                                                position: 'absolute',
                                                                left: 8,
                                                                zIndex: 2,
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                bgcolor: 'rgba(255,255,255,0.7)',
                                                                boxShadow: 2,
                                                                '&:hover': { bgcolor: theme.palette.primary.light },
                                                                border: '1px solid',
                                                                borderColor: theme.palette.divider,
                                                            }}
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                handlePrevMedia(row.id, mediaUrls.length);
                                                            }}
                                                        >
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 19L9.5 12L15.5 5" stroke={theme.palette.text.primary} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                        </IconButton>
                                                    )}
                                                    <CardMedia
                                                        component={mediaUrls[mediaIndex[row.id] || 0]?.match(/\.mp4$/i) ? 'video' : 'img'}
                                                        src={mediaUrls[mediaIndex[row.id] || 0]}
                                                        controls={mediaUrls[mediaIndex[row.id] || 0]?.match(/\.mp4$/i) ? true : undefined}
                                                        sx={{
                                                            maxWidth: '100%',
                                                            maxHeight: 320,
                                                            objectFit: 'contain',
                                                            margin: 'auto',
                                                            display: 'block',
                                                            width: '100%',
                                                            borderRadius: 2,
                                                            boxShadow: 1,
                                                            background: theme.palette.background.default
                                                        }}
                                                    />
                                                    {mediaUrls.length > 1 && (
                                                        <IconButton
                                                            size="medium"
                                                            sx={{
                                                                position: 'absolute',
                                                                right: 8,
                                                                zIndex: 2,
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                bgcolor: 'rgba(255,255,255,0.7)',
                                                                boxShadow: 2,
                                                                '&:hover': { bgcolor: theme.palette.primary.light },
                                                                border: '1px solid',
                                                                borderColor: theme.palette.divider,
                                                            }}
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                handleNextMedia(row.id, mediaUrls.length);
                                                            }}
                                                        >
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 5L14.5 12L8.5 19" stroke={theme.palette.text.primary} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                        </IconButton>
                                                    )}
                                                    {mediaUrls.length > 1 && (
                                                        <Box sx={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', bgcolor: 'rgba(0,0,0,0.5)', color: 'white', px: 1.5, py: 0.5, borderRadius: 2, fontSize: 13, fontWeight: 500, letterSpacing: 1, boxShadow: 1 }}>
                                                            {((mediaIndex[row.id] || 0) + 1) + ' / ' + mediaUrls.length}
                                                        </Box>
                                                    )}
                                                </Box>
                                            )}
                                            <CardActions disableSpacing sx={{ mt: 'auto' }}>
                                                <Divider />
                                                <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                                                    <Grid item xs={4}>
                                                        <Paper
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: '8px',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s',
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.secondary.main,
                                                                },
                                                                color: theme.palette.info.main,
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleOpenScheduledPost(row.id, true, 0);
                                                            }}
                                                        >
                                                            <VisibilityIcon fontSize="small" />
                                                            {!isMobile && <Typography sx={{ fontWeight: 700, ml: 1 }}>{translate('generated_post_pending_approval_grid.preview', 'Preview')}</Typography>}
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Paper
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: '8px',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s',
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.secondary.main,
                                                                },
                                                                color: theme.palette.primary.main,
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleApprovePost(row);
                                                            }}
                                                        >
                                                            <CheckCircleOutlinedIcon />
                                                            {!isMobile && <Typography sx={{ fontWeight: 700, ml: 1 }}>{translate('generated_post_pending_approval_grid.approve', 'Approve')}</Typography>}
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Paper
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: '8px',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s',
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.secondary.main,
                                                                },
                                                                color: theme.palette.error.main,
                                                            }}
                                                            onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeletePost(row);
                                                                    }}
                                                        >
                                                            <DeleteIcon />
                                                            {!isMobile && <Typography sx={{ fontWeight: 700, ml: 1 }}>{translate('generated_post_pending_approval_grid.delete', 'Delete')}</Typography>}
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            </CardActions>
                                        </Card>
                                        <GeneratedPostPendingApprovalGridActionPopup
                                            {...postActionProps}
                                            approvePostDetails={row}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        {confirmationDialogue && <ConfirmationDialog
                            open={confirmationDialogue.isOpen}
                            onClose={() => closeConfirmationDialogue()}
                            onConfirm={confirmationDialogue.submitFunction}
                            title={confirmationDialogue.title}
                            message={confirmationDialogue.message}
                            loading={loading}
                        />}
                    </Box>
                </>
            ) : (
                <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 150px)', maxHeight: 'calc(100vh - 150px)' }}>
                    <img src={NoApproval} style={{ width: '50%', height: '50%', maxWidth: '50%', maxHeight: '50%' }} alt="No Pending Approval" />
                </Card>
            )}
        </>
    );
};
export default GeneratedPostPendingApprovalGrid;